import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.agent.bankcard.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_BANK_CARD_ASYNC: `${uid}.saveBankCardAsync`,
    SAVE_BANK_CARD_SUCCESS: `${uid}.saveBankCardSuccess`,
    SAVE_BANK_CARD_FAILURE: `${uid}.saveBankCardFailure`,
    CREATE: `${uid}.create`,
};

export { ActionTypes };